export default __webpack_public_path__ + "assets/TrashCan.de02.svg";